/**
 * @fileoverview GET handler for the "/product_alerts/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { productAlertsId } from "./constants";
import type { ProductAlertResultItem } from "./types";
import { isProductAlertResultItem } from "./validators";

export const getProductAlert = reactQueryFetcherAdapter(
  productAlertsId,
  (signal: AbortSignal, id: string): Promise<ProductAlertResultItem> => {
    return fetch(`/product_alerts/${id}`, "GET", {}, { signal });
  },
  isProductAlertResultItem
);
